import _ from "lodash"
import React, { useState, useEffect, useRef } from "react"
import styled, { css } from "styled-components"
import { useApp } from "../../../store/app/selectors"
import { useItem, useItems, useItemsPath } from "../../../store/items/selectors"
import Breadcrumbs from "@material-ui/core/Breadcrumbs"
import Link from "@material-ui/core/Link"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import LastPageIcon from "@material-ui/icons/LastPage"
import NavTo from "./nav_to"

// ========================================= //
// Styles
// ========================================= //

const Container = styled.div`
  display: flex;
  align-items: center;
`

const LinkStyled = styled(Link)`
  display: flex;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s;
  color: ${(props) =>
    props.theme.toHSL(props.theme.colors.primary, { s: -20, l: -20 })};
  &:hover {
    text-decoration: none;
    color: ${(props) =>
      props.theme.toHSL(props.theme.colors.primary, { s: -20, l: -40 })};
  }
  ${(props) => props.current && current};
`

const Home = styled(LastPageIcon)`
  color: ${(props) =>
    props.theme.toHSL(props.theme.colors.primary, { s: -20, l: -40 })};
  transform: rotate(180deg);
  margin-right: 10px;
`

const current = css`
  font-weight: 400;
  font-size: 0.9rem;
  color: ${(props) =>
    props.theme.toHSL(props.theme.colors.primary, { s: -20, l: -40 })};
`

const NavigateNextIconStyled = styled(NavigateNextIcon)`
  color: ${(props) =>
    props.theme.toHSL(props.theme.colors.primary, { s: -20, l: -20 })};
`

// ========================================= //
// Main Component
// ========================================= //

const BreadcrumbsFrom = ({ id, maxItems = 3 }) => {
  // ========================================= //
  // State
  // ========================================= //

  const [name] = useItem([id, "name"])
  const [ids, actions] = useApp("views.board.path")
  const currentID = _.last(ids)
  // const [path] = useItemsPath(id)
  const [items] = useItems(ids, ["id", "name"])
  // console.log(items);
  
  const [, setRandomKey] = useState(_.random())
  const resetTimer = useRef(null)

  // ========================================= //
  // Effects
  // ========================================= //

  useEffect(() => {
    //if (_.first(ids) !== id || ) {
    actions.setSetting({ views: { board: { path: [id] } } })
    //}
  }, [id])

  useEffect(() => () => clearReset(), [])

  // ========================================= //
  // Functions
  // ========================================= //

  const handleHomeClick = () => {
    // actions.displayIntention({ id: "intentions", remove: true })
  }

  const handleClick = (event, id, index) => {
    console.log("link clicked")

    event.preventDefault()
    event.stopPropagation()
    // const childID = _.get(intentions[index + 1], "id", false)
    // if (isCurrent(index)) return actions.setMenuItem({ id, isOpen: true })
    // actions.displayIntention({ id: childID, remove: true })
  }

  const handleMaxItemClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleReset = () => {
    if (resetTimer.current) return
    resetTimer.current = setTimeout(() => setRandomKey(_.random(0, 100)), 1000)
  }

  const clearReset = () => {
    resetTimer.current = clearTimeout(resetTimer.current)
  }

  // ========================================= //
  // Render
  // ========================================= //

  return (
    <Container onMouseLeave={handleReset} onMouseEnter={clearReset}>
      <Breadcrumbs
        key={resetTimer.current}
        separator={<NavigateNextIconStyled fontSize="small" />}
        aria-label="breadcrumb"
        maxItems={maxItems}
        onClick={handleMaxItemClick}
      >
        {/* {_.map(_.slice(items, 0, -1), ({ itemID, name }, index) => ( */}
        {_.map(items, ({ id: itemID, name }, index) => (
          <LinkStyled
            key={index}
            // onClick={e => handleClick(e, itemID, index)}
            current={itemID === currentID ? 1 : 0}
          >

            <NavTo id={itemID}>{_.truncate(name, 20, "...")}</NavTo>
          </LinkStyled>
        ))}
      </Breadcrumbs>
    </Container>
  )
}

export default BreadcrumbsFrom
